$( document ).ready(function() {
    $('.blog-details').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.blog-details-post .article-header').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.icon-box h2').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.icon-content').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    //console.log('MATCH HEIGHT');

    $('.sector').click(function(){

        $('.sector').each(function () {
            $(this).removeClass("img-clicked");
        });

        $(this).addClass("img-clicked");

        var title = $( $(this).find('.sector-title')).text();
        var content = $( $(this).find('.sector-info')).html();
        var image = $( $(this).find('.sector-modal-img')).html();

        $('.modal-header').html(title);
        $('.modal-copy').html(content);
        $('.modal-image').attr('src', image);

        /*Foundation.SmoothScroll.scrollToLoc('#sector-content', {
            threshold: 50,
            offset: 100
        }, function(){
            //console.log('scrolled');
        });*/
    });

    var ele   = $('.blog-content');
    var speed = 25, scroll = 5, scrolling;

    $('.arrow-box-down').mouseenter(function() {
        scrolling = window.setInterval(function() {
            ele.scrollTop( ele.scrollTop() + scroll );
        }, speed);
    });

    $('.arrow-box-up').mouseenter(function() {
        scrolling = window.setInterval(function() {
            ele.scrollTop( ele.scrollTop() - scroll );
        }, speed);
    });

    $('.arrow-box-up, .arrow-box-down').bind({
        click: function(e) {
            // Prevent the default click action
            e.preventDefault();
        },
        mouseleave: function() {
            if (scrolling) {
                window.clearInterval(scrolling);
                scrolling = false;
            }
        }
    });

    /*var tl = new TimelineLite,
        mySplitText = new SplitText(".hero-title", {type:"words,chars"}),
        chars = mySplitText.chars; //an array of all the divs that wrap each character

    TweenMax.set(".hero-title", {perspective:400});
    tl.staggerTo(mySplitText.chars, 4, {css:{transformOrigin:"50% 50% -30px", rotationY:-360, rotationX:360, rotation:360}, ease:Elastic.easeInOut}, 0.02, "+=1");
*/
    /*$('#a-link').mouseenter(function (e){
        var tl2 = new TimelineLite,
            mySplitLink = new SplitText(this, {type:"chars"}),
            chars = mySplitLink.chars; //an array of all the divs that wrap each character

        tl2.staggerTo(mySplitLink.chars, 0.2, {css:{rotationY:-360}, ease:Elastic.easeInOut}, 0.02, "+=0.1");
        //TweenMax.to($(this), .2, {css:{opacity:0}});

    })*/

    if(window.location.href.indexOf("microsites") > -1) {

        let ST;
        startAnimation();

       function startAnimation() {

           //console.log('start');
           ST = new SplitText('.position', {type:"words"}), chars=ST.words, l=ST.words.length;
           //TweenMax.set(chars, {opacity:0, scale:2, y:"-50"});

           setTimeout(function(){
               TweenMax.staggerTo('.position', 0.2, {opacity:1, scale:1, rotationY:360, cycle:{delay:function(i){return Math.abs(Math.floor(l/2)-i)*0.02}},ease:Back.easeIn}, 0.04);
               TweenMax.staggerFrom(chars, 1.5, {opacity:0, scale:3, rotationY:180, cycle:{delay:function(i){return Math.abs(Math.floor(l/2)-i)*0.02}},ease:Back.easeIn}, 0.04);
               TweenMax.delayedCall(5, resetText);
           }, 100);

           function getRandomInt(max) {
               return Math.floor(Math.random() * Math.floor(max));
           }

           function resetText() {
               ST.revert();

              /* var posST;

               $('.position').mouseenter(function() {
                   //kill();
                   posST = new SplitText('.position', {type:"words"}), chars=posST.words, l=posST.words.length;
                   TweenMax.staggerTo(chars, 0.1, {color:"#8FE402", scale:0.9 ,ease:Back.easeIn}, 0.04);
                   TweenMax.staggerTo(chars, 0.2, {color:"white", scale:1, ease:Back.easeIn}, 0.04);
                   console.log('OVER');
               });

               function kill(){
                   posST.revert();
               }*/

           }

       }
    }

});

